import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AlertTriangle, CheckCircle2, Loader2 } from "lucide-react";
import RecruitGlanceLogo from "../components/RecruitGlanceLogo";

export default function VerifyEmail() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("token");

    if (!token) {
      setStatus("error");
      return;
    }

    fetch(`${process.env.REACT_APP_API_URL}/verify-email?token=${token}`)
      .then((res) => {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then(() => {
        setStatus("success");
        setTimeout(() => {
          navigate("/login?verified=true");
        }, 2000);
      })
      .catch(() => setStatus("error"));
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#03140f] px-6 text-slate-950">
      <div className="w-full max-w-md rounded-lg border border-white/10 bg-white p-6 text-center shadow-2xl shadow-black/30 sm:p-8">
        <div className="mb-6 flex justify-center">
          <RecruitGlanceLogo />
        </div>

        {status === "loading" && (
          <div>
            <Loader2 className="mx-auto animate-spin text-emerald-700" size={32} />
            <h1 className="mt-4 text-2xl font-semibold tracking-tight text-slate-950">
              Verifying your email
            </h1>
            <p className="mt-2 text-sm leading-6 text-slate-500">
              Please wait while RecruitGlance confirms your verification link.
            </p>
          </div>
        )}

        {status === "success" && (
          <div>
            <CheckCircle2 className="mx-auto text-emerald-700" size={36} />
            <h1 className="mt-4 text-2xl font-semibold tracking-tight text-slate-950">
              Email verified
            </h1>
            <p className="mt-2 text-sm leading-6 text-slate-500">
              Your account is ready. Redirecting you to sign in.
            </p>
          </div>
        )}

        {status === "error" && (
          <div>
            <AlertTriangle className="mx-auto text-rose-700" size={36} />
            <h1 className="mt-4 text-2xl font-semibold tracking-tight text-slate-950">
              Verification link is invalid
            </h1>
            <p className="mt-2 text-sm leading-6 text-slate-500">
              The link may have expired. Please request a new verification email.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
